
<template>
  <div>
    <base-card :with_actions="false">
      <template slot="title">
        <!-- <v-icon>mdi-drag</v-icon> -->
        <!-- <v-btn disabled icon color="" class="mr-1">
          <v-icon>mdi-check-circle-outline</v-icon>
        </v-btn> -->
        <span class="grey--text mr-2">
          #{{position}}
        </span>
        <b>
          {{ stage.name }}
        </b>
        <!-- <v-spacer></v-spacer> -->
      </template>
      <template slot="btn-slot">
        
        <v-btn x-small height="30px" color="accent" 
          class="mt-2 mt-sm-0 black--text elevation-0 text-capitalize font-weight-bold"
          @click="openDialogTask()" 
          :disabled="!$can('update', new entities.Stage(stage.use_type))"
        >
          <v-icon x-small>mdi-plus</v-icon>
          {{ $t('tasks.new') }}
        </v-btn>
        <v-spacer class='hidden-sm-and-up'></v-spacer>
        <v-btn small icon color="" @click="openStageConfig" class="ml-1"
          :disabled="!$can('update', new entities.Stage(stage.use_type))"
        >
          <v-icon color="black">mdi-cog</v-icon>
        </v-btn>
        <v-spacer class='hidden-sm-and-up'></v-spacer>
        <v-btn small icon color="" @click="open = !open" class="ml-1">
          <v-icon color="black">{{ open? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </template>


      <template v-slot:content v-if="open">
        <card-loading-transparent-linear v-if="loading"></card-loading-transparent-linear>
        <template v-if="!loading && tasks.length">
          <draggable v-model="tasks" v-bind="dragOptions" @change="reorder" @start="handleDragStart" @end="handleDragStop" draggable=".bacon" handle=".handle">
            <transition-group type="transition" :name="!is_dragging ? 'flip-list' : null">
              <v-col class="pa-0 mb-0 bacon" cols="12" v-for="(task, idx) in tasks" :key="task.id || task.ref">
                <v-row align="center" class="pa-3">
                  <v-col cols="11" class="pa-0" align='right'>
                    <base-info-card with_spacer @click="openTask(task, idx)">
                      <template slot="icon">
                        <v-icon ref="icon_draggable" class="handle" :style="{cursor: is_dragging? 'grabbing':'grab'}">mdi-drag</v-icon>
                        <span :class="['mr-3 handle bacon', any_task_with_same_positions && tasks_with_same_positions[task.position] > 1? 'red--text' : null]">
                          # {{ idx+1 }}
                        </span>
                      </template>
                      <template slot="text">
                        <span style="max-width: 35vw;" class="black--text title text-truncate"> 
                          {{ task.name }}
                        </span>
                      </template>
                      <template slot="last">
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-chip  class="my-1 my-sm-0 mr-2" v-on="on">
                              <v-avatar left>
                                <v-icon>mdi-format-list-checkbox</v-icon>
                              </v-avatar>
                              {{ task.json_attributes.subtasks.length }}
                            </v-chip>
                          </template>
                          {{ $t('tasks.subtasks.subtasks') }}
                        </v-tooltip>
                        <v-tooltip top v-if="false">
                          <template v-slot:activator="{on}">
                            <v-chip  class="my-1 my-sm-0" v-on="on">
                              <v-avatar left>
                                <v-icon>mdi-calendar</v-icon>
                              </v-avatar>
                              {{ task.default_duration_days }} {{$tc('day', 2).toLowerCase()}}
                            </v-chip>
                          </template>
                          {{ $t('tasks.expected_duration') }}
                        </v-tooltip>
                      </template>
                    </base-info-card>
                  </v-col>
                  <v-btn icon color="error" @click="removeTask(task.id)"
                    :disabled="!$can('update', new entities.Stage(stage.use_type))"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </transition-group>
          </draggable>
        </template>
        <span v-if="!loading && !tasks.length">
          {{ $t('tasks.none') }}
        </span>
      </template>
    </base-card>

    <dialog-one-stage v-if="config_stage" :stage="stage" :position="position" :max_positions="max_positions"
      @cancel="handleCancelStage"
      @done="handleDoneStage"
    ></dialog-one-stage>


    <dialog-one-task v-if="dialog_task" :is_new="!is_editing_task" :is_edit="is_editing_task" :task="editing_task" 
      taskable_type="Stage" :taskable_id="stage.id" :taskable_name="stage.name" :position="tasks.length+1"
      @cancel="handleCancelTask"
      @done="handleDoneTask"
    ></dialog-one-task>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import request_error_catch from '@/mixins/request_error_catch'
import draggable_helpers from '@/mixins/draggable_helpers'
import Api from '@/api/index';
import DialogOneStage from './DialogOneStage.vue';
import DialogOneTask from './DialogOneTask.vue';
import entities from '@/utils/entities';

export default {
  name: 'ShowOneStage',
  mixins: [ validations, draggable_helpers, request_error_catch ],
  components: {
    DialogOneStage,
    DialogOneTask
    //ComponentName: () => import(''),
  },
  props: {
    stage: {
      type: Object,
    },
    position: {
      type: [String, Number],
    },
    max_positions: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loading: false,
      open: false,
      tasks: [],
      tasks_bkp: [],
      config_stage: false,
      
      loading_tasks: false,

      dialog_task: false,

      editing_task: null,
      is_editing_task: false,

      any_task_with_same_positions: false,
      tasks_with_same_positions: {},

      entities: entities,

    }
  },
  methods: {
    reorder(){
      if (this.$can('edit', new entities.Stage(this.stage.use_type))) { 
        let obj = {
          id: this.stage.id,
          tasks_attributes: this.tasks.map((t, idx)=> {return {id: t.id, position: idx + 1}})
        }
        Api.Stage.update(obj).then(r=>r.data).then(d=> {
          // this.stage = {...d}
          // this.config_stage = false
          this.$emit('updatedStage', {...d}) 
          // this.getStageTasks()
        }).catch(err=> {
          console.log({err});
          this.catch_error(err)
        }).finally(()=> {

        })
      } else {
        this.addNotification({type: 'error', msg: 'Alterações não foram salvas, pois não possui permissões para isso'})
      }
    },
    openDialogTask(){
      this.dialog_task = true
    },
    handleBlur(e, field, ref){
      const {target: {validity: {valid}, validationMessage, _value} } = e
      // console.log({e, tg: e.target, vld: e.target.validity, valid});
      const text_field = e.target.parentElement.parentElement.parentElement.parentElement
      // console.log({text_field, pc: text_field._prevClass});

      let is_valid = true

      // console.log(this.$refs[ref]);

      if (!valid || text_field._prevClass.includes('error--text')){
        is_valid = false
      }

      if(!is_valid){
        let msg = validationMessage || text_field.textContent 
        if (!msg && ref){
          msg = this.$refs[ref].messagesToDisplay
        } else if (!msg && !ref){
          msg = 'Houve um erro.'
        }
        e.target.parentElement.parentElement.parentElement.parentElement.classList.add("rounder_error")
        this.addNotification({type: 'error', msg})
      } else {
        // console.log('ee', field);
        // this.updateStageField(field, _value)
      }
    },
    handleCancelStage(){
      this.config_stage = false 
    },
    handleCancelTask(e){
      this.dialog_task = false
      this.is_editing_task = false
      this.editing_task = null
    },
    handleDoneTask(e){
      this.dialog_task = false
      this.is_editing_task = false
      this.editing_task = null
      if (this.open){
        this.getStageTasks()
      }
    },
    openTask(task, idx){
      this.editing_task = {
        ...task,
        idx,
      }
      this.is_editing_task = true
      this.dialog_task = true
    },
    removeTask(task_id){
      Api.Task.delete(task_id).then(r=>r.data).then(d=> {
        this.getStageTasks()
      }).catch(err => {
        console.log({err});
        this.catch_error(err)
      }).finally(()=>{

      })
    },
    handleDoneStage(e){
      // console.log({e});
      const {id, name, qtd_alterations, position, default_duration_days} = e
      let obj = {id, name, qtd_alterations, position, default_duration_days}
      Api.Stage.update(obj).then(r=>r.data).then(d=> {
        // this.stage = {...d}
        this.config_stage = false
        this.$emit('updatedStage', {...d}) 
      }).catch(err=> {
        // console.log({err})
        this.catch_error(err)
      })
    },
    openStageConfig(){
      this.config_stage = true
    },
    updateStageField(field, val){
      // console.log({field});
      let obj = {
        id: this.stage.id,
      }
      obj[field] = val || this.stage[field] 
      Api.Stage.update(obj).then(r=>r.data).then(d=> {
        // this.stage = {...d}
      }).catch(err=> {
        console.log({err});
        this.catch_error(err)
      })
    },
    getStageTasks() {
      this.loading = true
      Api.Task.index({searches: {taskable_type_cont_any: ['Stage'], taskable_id_in: [this.stage.id]}, sorts: {position: 'asc'}}).then(r=>r.data).then(d=> {
        this.tasks = [...d.sort((a,b) => Number(a.json_attributes.position) - Number(b.json_attributes.position))]
        this.tasks_bkp = [...this.tasks]
      }).catch(err=> {
        console.log({err});
        this.catch_error(err)
      }).finally(()=> {
        setTimeout(() => {
          this.loading = false
        }, 500);
      })
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    // this.getStageTasks();
  },
  watch: {
    open(nv,ov) {
      if (nv){
        this.getStageTasks()
      } else if (nv == false){
        
      }
    }
  },
}
</script>

<style scoped>
  ::v-deep.rounder.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    border: solid 1px #a5a5a5;
    min-height: 30px !important;
    padding: 0 10px;
  }

  ::v-deep.rounder_error.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    border: solid 1px #ff0000;
    /* min-height: 30px !important; */
  }
</style>